export const ProductInfoEdit = () => {
    return <>info edit</>;
};

ProductInfoEdit.displayName = 'ProductInfoEdit';
